<script>
import moment from "moment";

export default {
  name: "CalendarEditDetail",
  props: {
    event: { type: Object },
    recurrence: { type: Object },
  },
  data() {
    return {
      currentEvent: {},
      currentRecurrence: {},
    };
  },
  created() {
    this.currentEvent = this.event;
    this.currentRecurrence = this.recurrence;
  },
  methods: {
    formatDateTime(date) {
      return date ? moment(date).format("DD/MM/yyyy HH:mm") : "-";
    },
    display(v) {
      if (v === null || v === undefined || v === "") return "—";
      return v;
    },
  },
};
</script>

<template>
  <div class="calendar-edit-detail">
    <div class="calendar-edit-detail__header">
      <div class="calendar-edit-detail__patient">
        <div class="calendar-edit-detail__section-title">Paciente</div>
        <div class="calendar-edit-detail__patient-name">
          {{
            currentEvent &&
            currentEvent.extendedProps &&
            currentEvent.extendedProps.pacients &&
            currentEvent.extendedProps.pacients.nome
              ? currentEvent.extendedProps.pacients.nome
              : "—"
          }}
        </div>
      </div>

      <div class="calendar-edit-detail__codes">
        <div class="calendar-edit-detail__code">
          <div class="calendar-edit-detail__label">Código Atendimento</div>
          <b-badge
            variant="secondary"
            class="calendar-edit-detail__code-badge font-monospace"
          >
            {{ display(currentEvent && currentEvent.extendedProps ? currentEvent.extendedProps.atendimento_id : null) }}
          </b-badge>
        </div>
        <div class="calendar-edit-detail__code">
          <div class="calendar-edit-detail__label">Código Agenda</div>
          <b-badge
            variant="light"
            class="calendar-edit-detail__code-badge font-monospace"
          >
            {{ display(currentEvent && currentEvent.id ? currentEvent.id : (currentEvent && currentEvent.extendedProps ? currentEvent.extendedProps.agenda_id : null)) }}
          </b-badge>
        </div>
      </div>
    </div>

    <div class="calendar-edit-detail__grid">
      <div
        v-if="
          currentEvent.extendedProps &&
          currentEvent.extendedProps.treatment &&
          currentEvent.extendedProps.approach
        "
        class="calendar-edit-detail__col"
      >
        <div class="calendar-edit-detail__section-title">Tratamentos</div>
        <div class="d-flex align-items-center flex-wrap">
          <b-badge variant="info" class="mr-1">
            {{ currentEvent.extendedProps.treatment.name }}
          </b-badge>
          <b-badge variant="primary" class="mr-1">
            {{ currentEvent.extendedProps.approach.name }}
          </b-badge>
        </div>
      </div>

      <div v-if="currentEvent.extendedProps && currentEvent.extendedProps.agreement" class="calendar-edit-detail__col">
        <div class="calendar-edit-detail__section-title">Convênio</div>
        <div class="calendar-edit-detail__value">
          {{ currentEvent.extendedProps.agreement.name }}
        </div>
      </div>

      <div class="calendar-edit-detail__col">
        <div class="calendar-edit-detail__section-title">Início do atendimento</div>
        <div class="calendar-edit-detail__value">
          {{ formatDateTime(currentEvent.start) }}
        </div>
      </div>

      <div class="calendar-edit-detail__col">
        <div class="calendar-edit-detail__section-title">Fim do atendimento</div>
        <div class="calendar-edit-detail__value">
          {{ formatDateTime(currentEvent.end) }}
        </div>
      </div>
    </div>

    <!-- Removido: conteúdo do "Parecer do Profissional" para evitar duplicação/renderização inesperada do HTML -->
  </div>
</template>

<style scoped>
.calendar-edit-detail {
  font-size: 0.95rem;
  color: #212529;
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 14px;
  padding: 14px 16px;
}

.calendar-edit-detail__header {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-start;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #f1f3f5;
}

.calendar-edit-detail__patient {
  flex: 1 1 280px;
  min-width: 220px;
}

.calendar-edit-detail__patient-name {
  font-weight: 700;
  font-size: 1.05rem;
  line-height: 1.25;
}

.calendar-edit-detail__codes {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: flex-start;
}

.calendar-edit-detail__code {
  min-width: 190px;
}

.calendar-edit-detail__label {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #868e96;
  margin-bottom: 6px;
}

.calendar-edit-detail__code-badge {
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 0.88rem;
}

.calendar-edit-detail__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 14px;
}

.calendar-edit-detail__col {
  min-width: 0;
}

.calendar-edit-detail__section-title {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #868e96;
  margin-bottom: 6px;
}

.calendar-edit-detail__value {
  font-weight: 600;
}

.calendar-edit-detail__note {
  margin: 14px 0 0 0;
  padding: 12px 14px;
  border-left: 4px solid #556ee6;
  background: #f8f9ff;
  border-radius: 10px;
}

@media (max-width: 576px) {
  .calendar-edit-detail__grid {
    grid-template-columns: 1fr;
  }
}
</style>

